import { doPostChatToken } from "./ApiService";

export function getTokenChat(): Promise<any> {
  const url = "/cad-api/rest/user/authentication";
  const headers = {};
  const payload = {
    keyId: process.env.VUE_APP_API_CHAT_TOKEN_KEY,
    keySecret: process.env.VUE_APP_API_CHAT_TOKEN_SECRET,
  };
  return doPostChatToken<any>(url, payload, headers);
}
